import React from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import styles from './children.less?modules';
import Warn from '@/assets/img/warn.svg';

/**
 * 头部OK按钮
 * @param {*} param
 */
const ModalChildren = (props) => {
  let {
    htmlType,
    size,
    fontsize,
    title,
    okText,
    cancelText,
    handleOk,
    handleCancel,
  } = props;

  return (
    <div className={styles.modalConfirmBox}>
      <div className={styles.warnTitleMsg}>
        <div>
          <img src={Warn} alt="无" />
        </div>
        <p>{title}</p>
      </div>
      <div className={styles.footBotton}>
        <ButtonML
          size={size ? size : 'normal'}
          value={okText ? okText : '确认'}
          htmlType={htmlType}
          fontsize={fontsize ? fontsize : '14px'}
          onClick={handleOk}
        />
        <ButtonML
          size={size ? size : 'normal'}
          value={cancelText ? cancelText : '取消'}
          htmlType={htmlType}
          fontsize={fontsize ? fontsize : '14px'}
          onClick={handleCancel}
        />
      </div>
    </div>
  );
};

export default ModalChildren;
